// useRouteBreadcrumbs.js
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // Import useNavigate
import { useDispatch, useSelector } from 'react-redux';
import { updateBreadcrumbs } from '../redux/actions/actions';

const useRouteBreadcrumbs = () => {
    const location = useLocation();
    const navigate = useNavigate(); // Initialize navigate
    const dispatch = useDispatch();
    const existingBreadcrumbs = useSelector(state => state.breadcrumbs.breadcrumbs);
    const userType = useSelector((state) => state.auth.userDetails?.user_type);
    useEffect(() => {
        // Split the current path into segments (e.g., '/my-templates/workflow-builder/3' becomes ['my-templates', 'workflow-builder', '3'])
        const pathSnippets = location.pathname.split('/')
            .filter(i => i && i !== 'workflow-builder');

        // Generate new breadcrumbs based on the current path
        const newBreadcrumbs = pathSnippets.map((snippet, index) => {
            const path = '/' + pathSnippets.slice(0, index + 1).join('/');
            return { path, label: snippet };
        });

        // Ensure we always start with the root breadcrumb (e.g., Dashboard)
        const rootBreadcrumb = {
            path: userType === 2 ? '/partner-dashboard' : '/dashboard',
            label: 'Dashboard',
        };

        // Reset breadcrumbs only when navigating to '/dashboard'
        if (location.pathname === '/dashboard') {
            if (existingBreadcrumbs.length !== 1 || existingBreadcrumbs[0].path !== rootBreadcrumb.path) {
                dispatch(updateBreadcrumbs([rootBreadcrumb]));
            }
            return;
        }

        const existingBreadcrumbsCopy = [...existingBreadcrumbs];
        const updatedBreadcrumbs = [rootBreadcrumb, ...newBreadcrumbs];

        // Only dispatch if breadcrumbs have changed to prevent unnecessary re-renders
        if (
            updatedBreadcrumbs.length !== existingBreadcrumbsCopy.length ||
            updatedBreadcrumbs.some((crumb, index) => crumb.path !== existingBreadcrumbsCopy[index]?.path)
        ) {
            dispatch(updateBreadcrumbs(updatedBreadcrumbs));
        }

    }, [location.pathname, dispatch, existingBreadcrumbs, userType]);

    return { breadcrumbs: existingBreadcrumbs, navigate };
};

export default useRouteBreadcrumbs;
